class ShippingNotice extends HTMLElement {
  constructor() {
    super();
    // Determine if this is a product page or cart page shipping notice
    this.isProductPage = this.classList.contains('product-shipping-notice');
    
    // Get the appropriate checkbox ID based on context
    const checkboxId = this.isProductPage ? 'product-shipping-notice-checkbox' : 'shipping-notice-checkbox';
    
    this.checkboxEl = this.querySelector(`#${checkboxId}`);
    
    // Get content from data attributes
    this.modalTitle = this.getAttribute('data-title') || 'Important Shipping Notice';
    this.modalContent = this.getAttribute('data-content') || '';
    this.declineText = this.getAttribute('data-decline-text') || 'Decline';
    this.confirmText = this.getAttribute('data-confirm-text') || 'I Understand';
    
    // Create modal element dynamically
    this.createModal();
    
    // Different selectors based on context (product page vs cart page)
    if (this.isProductPage) {
      // this.checkoutButtonEl = document.querySelector('.product-form__submit');
      this.checkoutButtonEl = null;// on the product page, add to cart button should not be disabled
      this.additionalCheckoutButtonsEl = document.querySelector('.product-dynamic-checkout-buttons');
    } else {
      this.checkoutButtonEl = document.getElementById('checkout');
      this.additionalCheckoutButtonsEl = document.querySelector('.cart__dynamic-checkout-buttons');
    }
    
    this.init();
  }

  createModal() {
    // Check if modal already exists (avoid duplicates)
    if (document.getElementById('shipping-notice-modal')) {
      this.modalEl = document.getElementById('shipping-notice-modal');
      this.modalTitleEl = this.modalEl.querySelector('.shipping-notice-modal-title');
      this.modalBodyEl = this.modalEl.querySelector('.shipping-notice-modal-body');
      this.modalOpenEl = this.querySelector('.shipping-notice-link');
      this.modalCloseEl = this.modalEl.querySelector('.shipping-notice-modal-close');
      this.modalConfirmEl = this.modalEl.querySelector('.shipping-notice-modal-confirm');
      this.modalDeclineEl = this.modalEl.querySelector('.shipping-notice-modal-decline');
      return;
    }
    
    // Create modal structure
    const modalHTML = `
      <div id="shipping-notice-modal" class="shipping-notice-modal">
        <div class="shipping-notice-modal-content">
          <span class="shipping-notice-modal-close">&times;</span>
          <div class="shipping-notice-modal-title"></div>
          <div class="shipping-notice-modal-body"></div>
          <div class="shipping-notice-modal-footer">
            <button class="shipping-notice-modal-button shipping-notice-modal-decline"></button>
            <button class="shipping-notice-modal-button shipping-notice-modal-confirm"></button>
          </div>
        </div>
      </div>
    `;
    
    // Insert modal into the document
    document.body.insertAdjacentHTML('beforeend', modalHTML);
    
    // Set references to modal elements
    this.modalEl = document.getElementById('shipping-notice-modal');
    this.modalTitleEl = this.modalEl.querySelector('.shipping-notice-modal-title');
    this.modalBodyEl = this.modalEl.querySelector('.shipping-notice-modal-body');
    this.modalOpenEl = this.querySelector('.shipping-notice-link');
    this.modalCloseEl = this.modalEl.querySelector('.shipping-notice-modal-close');
    this.modalConfirmEl = this.modalEl.querySelector('.shipping-notice-modal-confirm');
    this.modalDeclineEl = this.modalEl.querySelector('.shipping-notice-modal-decline');
  }

  init() {
    // Set modal content from data attributes
    if (this.modalTitleEl) {
      this.modalTitleEl.textContent = this.modalTitle;
    }
    
    if (this.modalBodyEl) {
      // Handle HTML content safely
      this.modalBodyEl.innerHTML = this.decodeHTMLEntities(this.modalContent);
    }
    
    // Set button text
    if (this.modalDeclineEl) {
      this.modalDeclineEl.textContent = this.declineText;
    }
    
    if (this.modalConfirmEl) {
      this.modalConfirmEl.textContent = this.confirmText;
    }
    
    // Initially disable checkout button if checkbox exists and is not checked
    if (this.checkboxEl && !this.checkboxEl.checked) {
      this.toggleCheckoutButtons(false);
    }

    // Add event listeners
    if (this.checkboxEl) {
      // When checkbox is clicked, show the modal and prevent default checkbox behavior
      this.checkboxEl.addEventListener('click', this.handleCheckboxClick.bind(this));
    }
    
    if (this.modalOpenEl) {
      this.modalOpenEl.addEventListener('click', this.openModal.bind(this));
    }
    
    if (this.modalCloseEl) {
      this.modalCloseEl.addEventListener('click', this.closeModal.bind(this));
    }
    
    if (this.modalConfirmEl) {
      // When "I Understand" is clicked, check the checkbox and close modal
      this.modalConfirmEl.addEventListener('click', this.handleConfirmClick.bind(this));
    }
    
    if (this.modalDeclineEl) {
      // When "Decline" is clicked, close the modal without checking the checkbox
      this.modalDeclineEl.addEventListener('click', this.handleDeclineClick.bind(this));
    }
    
    // Close modal when clicking outside
    window.addEventListener('click', (event) => {
      if (event.target === this.modalEl) {
        this.closeModal();
      }
    });
  }
  
  // Helper function to decode HTML entities
  decodeHTMLEntities(text) {
    const textArea = document.createElement('textarea');
    textArea.innerHTML = text;
    return textArea.value;
  }

  handleCheckboxClick(event) {
    // Prevent the default checkbox behavior
    event.preventDefault();
    
    // Open the modal
    this.openModal();
  }

  handleConfirmClick() {
    // Check the checkbox
    if (this.checkboxEl) {
      this.checkboxEl.checked = true;
      this.toggleCheckoutButtons(true);
    }
    
    // Close the modal
    this.closeModal();
  }
  
  handleDeclineClick() {
    // Ensure the checkbox remains unchecked
    if (this.checkboxEl) {
      this.checkboxEl.checked = false;
      this.toggleCheckoutButtons(false);
    }
    
    // Close the modal
    this.closeModal();
  }

  toggleCheckoutButtons(enable) {
    // Toggle main checkout button
    if (this.checkoutButtonEl) {
      if (enable) {
        this.checkoutButtonEl.classList.remove('checkout-button-disabled');
      } else {
        this.checkoutButtonEl.classList.add('checkout-button-disabled');
      }
    }
    
    // Toggle additional checkout buttons visibility
    if (this.additionalCheckoutButtonsEl) {
      if (enable) {
        this.additionalCheckoutButtonsEl.classList.remove('checkout-button-disabled');
      } else {
        this.additionalCheckoutButtonsEl.classList.add('checkout-button-disabled');
      }
    }
  }

  openModal() {
    if (this.modalEl) {
      this.modalEl.style.display = 'block';
    }
  }

  closeModal() {
    if (this.modalEl) {
      this.modalEl.style.display = 'none';
    }
  }
}

customElements.define('shipping-notice', ShippingNotice);
